import { render, staticRenderFns } from "./modalViewDCS.vue?vue&type=template&id=313a05a7&"
import script from "./modalViewDCS.vue?vue&type=script&lang=js&"
export * from "./modalViewDCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports